module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-main",
    class: {
      'load': _vm.load
    }
  }, [_c('a', {
    staticClass: "main-dialog",
    class: {
      'map-animation': _vm.mapAnimation && !_vm.$root.isMobile
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loadClick('Inner page')
      }
    }
  }, [_c('h1', {
    staticClass: "main-dialog-h1"
  }, [_vm._v("Там, где тепло")]), _vm._v(" "), _c('p', {
    staticClass: "main-dialog-p"
  }, [_vm._v("\n            В мире есть места, которые, словно тепловая карта,\n            пульсируют жаром новых впечатлений. Чтобы вам было легче\n            в новом путешествии, мы подобрали 50 невероятных мест,\n            и узнали о том, как их лучше всего фотографировать.\n            А вам лишь останется выложить фотографию в социальную\n            сеть и ждать сотни лайков.")]), _vm._v(" "), _c('a', {
    staticClass: "main-dialog-arrow",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loadClick('Inner page')
      }
    }
  }, [_c('arrow')], 1)]), _vm._v(" "), _c('p', {
    staticClass: "map-text"
  }, [_vm._v("Кликните на интересующую вас страну на карте или выберите ее из списка")]), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "main-circles",
    class: {
      'map-animation': _vm.mapAnimation
    }
  }, [_c('div', {
    staticClass: "map-side-left"
  }), _vm._v(" "), _c('a', {
    staticClass: "map-center",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loadClick('Inner page')
      }
    }
  }, [_c('div', {
    staticClass: "map"
  }, [_c('earth', {
    staticClass: "earth"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "map-side-right"
  })]) : _c('div', {
    staticClass: "main-circles",
    class: {
      'map-animation': _vm.mapAnimation && !_vm.$root.isMobile
    }
  }, [_c('div', {
    staticClass: "map-side-left"
  }), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "map-center"
  }, [_c('div', {
    staticClass: "map"
  }, [_c('earth', {
    staticClass: "earth"
  })], 1)]) : _c('div', {
    staticClass: "map-center",
    style: ({
      transform: 'translate(' + _vm.mapPosition[_vm.swiperIndex].left + '%, ' + _vm.mapPosition[_vm.swiperIndex].top + '%) scale(15)'
    })
  }, [_c('div', {
    staticClass: "map",
    class: _vm.mapPosition[_vm.swiperIndex].name,
    on: {
      "click": _vm.linkCountry
    }
  }, [_c('earth', {
    staticClass: "earth"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "map-side-right"
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('p', [_vm._v("\n            Выбор страны:\n        ")]), _vm._v(" "), (!_vm.$root.isMobile) ? _c('div', {
    staticClass: "menu-links"
  }, [_c('router-link', {
    staticClass: "link-germany",
    attrs: {
      "to": "/country/germany"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Germany')
      }
    }
  }, [_vm._v("Германия")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-greece",
    attrs: {
      "to": "/country/greece"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Greece')
      }
    }
  }, [_vm._v("Греция")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-israel",
    attrs: {
      "to": "/country/israel"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Israel')
      }
    }
  }, [_vm._v("Израиль")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-spain",
    attrs: {
      "to": "/country/spain"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Spain')
      }
    }
  }, [_vm._v("Испания")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-italy",
    attrs: {
      "to": "/country/italy"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Italy')
      }
    }
  }, [_vm._v("Италия")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-tailandia",
    attrs: {
      "to": "/country/tailandia"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Tailandia')
      }
    }
  }, [_vm._v("Таиланд")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-turkey",
    attrs: {
      "to": "/country/turkey"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Turkey')
      }
    }
  }, [_vm._v("Турция")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-france",
    attrs: {
      "to": "/country/france"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('France')
      }
    }
  }, [_vm._v("Франция")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-oae",
    attrs: {
      "to": "/country/oae"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Oae')
      }
    }
  }, [_vm._v("ОАЭ")]), _vm._v(" "), _c('router-link', {
    staticClass: "link-korea",
    attrs: {
      "to": "/country/korea"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Korea')
      }
    }
  }, [_vm._v("Южная Корея")])], 1) : _c('swiper', {
    ref: "swiperTop",
    staticClass: "gallery-top",
    attrs: {
      "options": _vm.swiperOptionTop
    },
    on: {
      "slideChange": _vm.slideChanged
    }
  }, [_c('swiper-slide', [_c('router-link', {
    staticClass: "link-germany",
    attrs: {
      "to": "/country/germany"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Germany')
      }
    }
  }, [_vm._v("Германия")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-greece",
    attrs: {
      "to": "/country/greece"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Greece')
      }
    }
  }, [_vm._v("Греция")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-israel",
    attrs: {
      "to": "/country/israel"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Israel')
      }
    }
  }, [_vm._v("Израиль")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-spain",
    attrs: {
      "to": "/country/spain"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Spain')
      }
    }
  }, [_vm._v("Испания")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-italy",
    attrs: {
      "to": "/country/italy"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Italy')
      }
    }
  }, [_vm._v("Италия")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-tailandia",
    attrs: {
      "to": "/country/tailandia"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Tailandia')
      }
    }
  }, [_vm._v("Таиланд")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-turkey",
    attrs: {
      "to": "/country/turkey"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Turkey')
      }
    }
  }, [_vm._v("Турция")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-france",
    attrs: {
      "to": "/country/france"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('France')
      }
    }
  }, [_vm._v("Франция")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-oae",
    attrs: {
      "to": "/country/oae"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Oae')
      }
    }
  }, [_vm._v("ОАЭ")])], 1), _vm._v(" "), _c('swiper-slide', [_c('router-link', {
    staticClass: "link-korea",
    attrs: {
      "to": "/country/korea"
    },
    on: {
      "click": function($event) {
        _vm.gaSend('Korea')
      }
    }
  }, [_vm._v("Южная Корея")])], 1)], 1), _vm._v(" "), (_vm.$root.isMobile) ? _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }, [_c('arrowSlide')], 1) : _vm._e(), _vm._v(" "), (_vm.$root.isMobile) ? _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }, [_c('arrowSlide')], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e138c04c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Main.vue
// module id = 508
// module chunks = 1